<div *ngIf="app" class="template-name">
	<ie-form-field [label]="'NAME' | translate">
		<input
			type="text"
			class="ie-form-field-styling"
			[(ngModel)]="app.name"
		/>
	</ie-form-field>
	<div class="app-dimensions">
		<ie-form-field [label]="'WIDTH' | translate">
			<input
				type="number"
				class="ie-form-field-styling"
				[(ngModel)]="app.width"
				(change)="onDimensionChanged('w')"
			/>
		</ie-form-field>
		<div class="ie-icon-button" (click)="aspectRatioLocked = !aspectRatioLocked" [title]="(aspectRatioLocked ? 'UN' : '') + 'LOCK_ASPECT_RATIO' | translate">
			<i class="fa lock-aspect-ratio" [ngClass]="{'fa-chain': aspectRatioLocked, 'fa-chain-broken': !aspectRatioLocked}"></i>
		</div>
		<ie-form-field [label]="'HEIGHT' | translate">
			<input
				type="number"
				class="ie-form-field-styling"
				[(ngModel)]="app.height"
				(change)="onDimensionChanged('h')"
			/>
		</ie-form-field>
	</div>
	<ie-form-field [label]="'DESCRIPTION' | translate">
		<textarea
			type="text"
			class="ie-form-field-styling"
			[(ngModel)]="app.description"
		></textarea>
	</ie-form-field>
</div>
<div *ngIf="timelineWidgets && app?.id">
	<div class="app-widgets" *ngIf="timelineWidgets?.length && optionsByType">
		<h6>{{ 'TEMPLATE_WIDGETS_EXPOSED_PROPERTIES' | translate }}</h6>
		<div class="row-wrapper">
			<div class="header">
				<span>{{ 'WIDGET' | translate }}</span>
				<span>{{ 'EDITABLE_PROPERTIES' | translate }}</span>
			</div>
			<ng-container *ngFor="let widget of timelineWidgets; let i = index;">
				<div class="widget">
					<span class="label">
						<span class="icon" [innerHTML]="widget?.type | widgetIcon"></span>
						{{ widget.label }}
					</span>
					<span class="exposed-properties">
						<ie-form-field>
							<bb-entity-selector
								[(ngModel)]="app.exposedProperties[widget.id]"
								[options]="optionsByType[widget.type]"
								[name]="widget?.id + '_props'"
								[multi]="true"
								theme="dark"
							></bb-entity-selector>
						</ie-form-field>
					</span>
				</div>
			</ng-container>
		</div>
	</div>
</div>
<div class="button-bar">
	<!-- implement later? -->
	<!-- <div class="delete-button bar-button" (click)="onDeleteClick()">
		{{ 'DELETE' | translate }}
	</div> -->
	
	<div class="bar-button" (click)="onCancelClick()">
		{{ 'CANCEL' | translate }}
	</div>

	<div class="save-button bar-button" (click)="onSaveClick()">
		{{ 'SAVE' | translate }}
	</div>
</div>
